import { render, staticRenderFns } from "./sampleReturn.vue?vue&type=template&id=78029da9&scoped=true&"
import script from "./sampleReturn.vue?vue&type=script&lang=js&"
export * from "./sampleReturn.vue?vue&type=script&lang=js&"
import style0 from "./sampleReturn.vue?vue&type=style&index=0&id=78029da9&lang=scss&scoped=true&"
import style1 from "./sampleReturn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78029da9",
  null
  
)

export default component.exports